import { cx } from "@jugl-web/utils";
import { SelectHTMLAttributes, forwardRef } from "react";

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      className={cx(
        "border-t-0 border-l-0 border-r-0 border-b border-solid border-b-black/20 p-2.5 outline-none",
        "text-base font-medium leading-4 text-[#363636] transition-colors",
        "placeholder:text-grey placeholder:font-normal",
        "focus:border-b-primary",
        className
      )}
      {...props}
    />
  )
);
